export class SourcesCallbackResponse {
	error: boolean;
	sourceId: string;
	errorMessages: string[];
}